import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/background/login_bg@2x.png'
import _imports_1 from '@/assets/icon/logo@2x.png'
import _imports_2 from '@/assets/icon/login_ic_code@2x.png'
import _imports_3 from '@/assets/icon/login_ic_phone@2x.png'
import _imports_4 from '@/assets/icon/login_ic_password@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-20ff789e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wx" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wx_bg",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "wx_login" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wx_login_icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "DM云工厂", -1))
const _hoisted_6 = { class: "wx_login_list" }
const _hoisted_7 = { class: "wx_login_list_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_9 = { class: "wx_login_list_item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_11 = { class: "wx_login_list_item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))

import { onMounted, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { wxAccountLogin, getUserInfo, wxProgramLogin } from '@/apis/index';
import { Toast } from 'vant';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

let from: any = reactive({
    openid: '',
    unionid: '',
    companyId: '',
    username: '',
    password: ''
})

const login = async () => {
    // if (!from.openid) return Toast('openid不能为空')
    // if (!from.unionid) return Toast('unionid不能为空')
    if (!from.companyId) return Toast('企业代码不能为空')
    if (!from.username) return Toast('手机号不能为空')
    if (!from.password) return Toast('密码不能为空')
    Toast.loading({
        message: '登录中...',
        forbidClick: true
    });
    let res = await wxAccountLogin(from)
    if (res.code === 200) {
        let info = await getUserInfo()
        if (info.code === 200) {
            await store.commit('setEntrance', 'XCX')
            await store.commit('setUserInfo', info.data)
            await store.dispatch('getMenuList', 2)
            await router.replace('/workbench')
        }
    }
    Toast.clear();
}

onMounted(() => {
    wxProgramLogin({ code: route.query.code })
        .then(async (res) => {
            if (res.code === 200) {
                // 免登录，直接跳首页
                if (res.data.loginStatus == 0) {
                    let info = await getUserInfo()
                    if (info.code === 200) {
                        await store.commit('setEntrance', 'XCX')
                        await store.commit('setUserInfo', info.data)
                        await store.dispatch('getMenuList', 2)
                        await router.replace('/workbench')
                    }
                } else {
                    from.openid = res.data.openid
                    from.unionid = res.data.unionid
                }
            }
        })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(from).companyId) = $event)),
            placeholder: "企业代码"
          }, null, 512), [
            [_vModelText, _unref(from).companyId]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            maxlength: "11",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(from).username) = $event)),
            placeholder: "手机号"
          }, null, 512), [
            [_vModelText, _unref(from).username]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(from).password) = $event)),
            placeholder: "密码"
          }, null, 512), [
            [_vModelText, _unref(from).password]
          ])
        ])
      ]),
      _createElementVNode("div", { class: "wx_login_footer" }, [
        _createElementVNode("div", {
          class: "wx_login_footer_btn",
          onClick: login
        }, "立即登录")
      ])
    ])
  ]))
}
}

})